import { createSelector } from 'reselect'
import * as ExerciseTypes from './Exercise.types'
import { AppState } from 'store/types'
import { EnglishDialect, selectEnglishDialect } from '../User'
import { getTextToSpeechLink } from './Exercise.utils'

export const selectLoadedExercisesBookIds = (state: AppState) => state.exercise.loadedExercisesBookIds

export const selectSentenceBuilderEntities = (state: AppState) => state.exercise.sentenceBuilderEntities

export const selectWordBuilderEntities = (state: AppState) => state.exercise.wordBuilderEntities

export const selectStudySets = (state: AppState) => state.exercise.studySets

export const selectCurrentStudySet = (state: AppState) =>
  state.exercise.studySets.find(({ _id }) => _id === state.exercise.currentStudySetId)

export const selectDifficultWordsAndMasteredCount = (state: AppState) => ({
  difficultWords: state.exercise.difficultWords,
  masteredCount: state.exercise.masteredWordsCount
})

export const selectExercisesByCurrentBookId = createSelector(
  (state: AppState) => state,
  (appState) => {
    const currentBookId = appState.book.currentBookId
    const exerciseEntities = appState.exercise.entities
    const englishDialect = selectEnglishDialect(appState)

    return exerciseEntities
      .filter(
        (exerciseEntity) =>
          exerciseEntity.bookId === currentBookId && exerciseEntity.type !== ExerciseTypes.ExerciseType.ReadWordRace
      )
      .map((exercise) => {
        if (exercise.type !== ExerciseTypes.ExerciseType.ReadSentence) {
          return exercise
        }

        return {
          ...exercise,
          recordingUrl: getRecordingUrl(exercise, englishDialect)
        }
      })
  }
)

const getRecordingUrl = (exercise: any, englishDialect: EnglishDialect) => {
  return getTextToSpeechLink(exercise.data.sentence.replace('...', ''), englishDialect)
}
